import './PolicyPages.css';

export const CookiePolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Cookie Policy</h1>
        <p className="last-updated">Last updated: October 30, 2025</p>

        <section>
          <h2>Introduction</h2>
          <p>
            This Cookie Policy explains how SMPP Decoder ("we", "us", or "our") uses cookies and similar technologies 
            when you visit our website. This policy should be read together with our Privacy Policy.
          </p>
        </section>

        <section>
          <h2>What Are Cookies?</h2>
          <p>
            Cookies are small text files that are placed on your device when you visit a website. They are widely used 
            to make websites work more efficiently and provide information to website owners.
          </p>
        </section>

        <section>
          <h2>Cookies We Use</h2>
          
          <h3>Essential Cookies</h3>
          <p>
            These cookies are necessary for the website to function properly. They enable basic functions like 
            storing your PDU in the URL for sharing and remembering your preferences.
          </p>
          <ul>
            <li><strong>URL Parameters:</strong> Used to persist PDU data in shareable links</li>
            <li><strong>Browser Storage:</strong> May be used for temporary data storage for application functionality</li>
          </ul>

          <h3>Advertising Cookies (Google AdSense)</h3>
          <p>
            We use Google AdSense to display advertisements on our website. Google AdSense uses cookies to:
          </p>
          <ul>
            <li>Show relevant ads based on your interests</li>
            <li>Measure ad performance and effectiveness</li>
            <li>Limit the number of times you see an ad</li>
          </ul>
          <p>
            You can learn more about how Google uses cookies by visiting{' '}
            <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">
              Google's Privacy & Terms
            </a>.
          </p>
        </section>

        <section>
          <h2>Managing Cookies</h2>
          <p>
            Most web browsers allow you to control cookies through their settings. However, if you disable cookies, 
            some features of our website may not function properly.
          </p>
          <p>
            You can opt out of personalized advertising by visiting:
          </p>
          <ul>
            <li>
              <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer">
                Google Ads Settings
              </a>
            </li>
            <li>
              <a href="https://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer">
                Digital Advertising Alliance
              </a>
            </li>
          </ul>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            We may update this Cookie Policy from time to time. We will notify you of any changes by posting the 
            new policy on this page and updating the "Last updated" date.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>
            If you have any questions about this Cookie Policy, please contact us through our website.
          </p>
        </section>

        <div className="back-link">
          <a href="/">← Back to SMPP Decoder</a>
        </div>
      </div>
    </div>
  );
};
